import { MEDICATION_BADGE_STATUS, TMedicationBadgeStatus } from "./activityCardStatus";
import { TReadingTagTone } from "../components/home/ActivityCard/ReadingTag";

export const MEDICATION_BADGE_TONES: Record<TMedicationBadgeStatus, { tone: TReadingTagTone; labelKey: string }> = {
    [MEDICATION_BADGE_STATUS.IN_SLOT]: {
        tone: 'ok',
        labelKey: 'screens.activities.card.medicationBadge.onTime',
    },
    [MEDICATION_BADGE_STATUS.OUT_OF_SLOT]: {
        tone: 'warn',
        labelKey: 'screens.activities.card.medicationBadge.outOfSchedule',
    },
    [MEDICATION_BADGE_STATUS.NOT_TAKEN]: {
        tone: 'neutral',
        labelKey: 'screens.activities.card.medicationBadge.notTaken',
    },
    [MEDICATION_BADGE_STATUS.NOT_REGISTERED]: {
        tone: 'neutral',
        labelKey: 'screens.activities.card.medicationBadge.notRegistered',
    },
};
